/* eslint-disable jsx-a11y/iframe-has-title */
import "./ContactUs.css";
import phone from "../../images/phone.svg";
import calendar from "../../images/calendar.svg";
import { ReactSVG } from "react-svg";
import {
  ContactAndWorkTimeResponse,
  fetchContactAndWorkTime,
} from "src/network/fetchContactAndWorkTime";
import { useEffect, useState } from "react";
function ContactUs() {
  const [contactDetails, setContactDetails] =
    useState<ContactAndWorkTimeResponse>();

  useEffect(() => {
    const getContactDetails = async () => {
      try {
        const contacts = await fetchContactAndWorkTime();
        setContactDetails(contacts);
      } catch (error) {
        console.error("Failed to fetch ContactDetails:", error);
      }
    };

    getContactDetails();
  }, []);

  return (
    <div>
      <div id="contact-us" className="contact-us-section">
        <div className="contact-details">
          <div className="card-icon">
            <ReactSVG src={phone} />
          </div>
          <h2 className="contact-title">Contact Us</h2>
          <div className="line"></div>
          <div className="card-content">
            <p>
              {contactDetails?.contact_details.email.details?.[0].email ?? ""}
            </p>
            <div className="line"></div>
            <p>{contactDetails?.contact.phone ?? ""}</p>
            <p>{contactDetails?.contact.mobile?.[0] ?? ""}</p>

            <div className="line"></div>
            <p>
              {contactDetails?.contact_details.address.details.location ?? ""}
            </p>
          </div>
        </div>

        <div className="map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13642.461533507969!2d29.984103!3d31.259068999999997!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe247226154f596e0!2sDOTMEDICA%20(Diving%20Offshore%20Training%20Medical%20Agency)!5e0!3m2!1sen!2seg!4v1633200371016!5m2!1sen!2seg"
            width={330}
            height={250}
            style={{ border: 0 }}
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="opening-hours">
          <div className="card-icon">
            <ReactSVG src={calendar} />
          </div>
          <div className="card-content">
            {Object.entries(contactDetails?.work_time || {}).map(
              ([day, time]) => (
                <div key={day}>
                  <div className="day-row">
                    <div className="day-name">{day}</div>
                    <div className="day-time">{time}</div>
                  </div>
                  <div className="line"></div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <div className="copyright-row">powerd by dotmedica 2025</div>
    </div>
  );
}

export default ContactUs;
